<template>
  <div>
    <PageName :title="`${isEdit ? 'Редактировать' : 'Создать'} договор с агентством`"/>
    <Form :value="contract" @request="saveContract" class="create__contract">
      <div class="create__contract-form">
        <VInput name="name" required placeholder="Номер договора" />
        <VInput name="contract_at" type="date" required placeholder="Дата договора" />
      </div>
      <div>
        <Button
            :loading="saveLoading"
            width="228px"
            height="48px"
            :text="isEdit ? 'Сохранить' : 'Создать'"
            class="btn-primary"
        />
        <Button
            @click.native.prevent="$router.go(-1)"
            width="228px"
            height="48px"
            text="Отменить"
            class="btn-secondary"
            style="margin-top: 12px"
        />
      </div>
    </Form>
  </div>
</template>

<script>
import PageName from "@/components/PageName.vue";
import Form from "@/components/Form/Form";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import {createContract, getContract, updateContract} from "@/api/contracts";
import {parseDate, simpleDate} from "@/utils/filters/dateFilters";
import {mapActions} from "vuex";

export default {
  name: "SaveContract",
  components: {
    PageName,
    Form,
    VInput,
    Button
  },
  props: {
    action: String
  },
  data(){
    return {
      contract: {},
      contractLoading: true,
      id: null,
      saveLoading: false,
    }
  },
  async mounted() {
     if (this.isEdit) {
      this.id = parseInt(this.$route.params.id_contract);
      await getContract(this.id).then(res => {
        res.data.contract_at = simpleDate(res.data.contract_at)
        this.contract = {
          ...res.data
        }
      })
    }
  },
  computed: {
    isEdit() {
      return this.action === 'update'
    },
    isCreate() {
      return this.action === 'create'
    },
  },
  methods: {
    ...mapActions("contracts", ["getContracts"]),
    async saveContract(data) {
      const {
        name,
        contract_at,
      } = data
      this.saveLoading = true;
      if (!this.isEdit) {
        await createContract(
            name,
            contract_at ? parseDate(contract_at) : null,
        )
      } else {
        await updateContract(
            this.contract.id,
            name,
            contract_at ? parseDate(contract_at) : null,
        )
      }
      this.saveLoading = false
      this.getContracts()
      this.$router.push({ name: "Contracts" });
    }
  }
}
</script>

<style scoped lang="scss">
.create__contract {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  .create__contract-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;
  }
}
</style>